import React from "react";

const MESSAGE = "Un paquet de feuilles offert pour 50 EUR d'achat !";

// Bandeau défilant (marquee) affiché sous le header
const PromoBanner: React.FC = () => {
    return (
        <div className="relative z-40 bg-accent text-white overflow-hidden border-b border-white/10">
            <div className="flex w-max animate-[marquee_20s_linear_infinite] hover:[animation-play-state:paused]">
                {[0, 1].map((group) => (
                    <div
                        key={group}
                        className="flex shrink-0"
                        aria-hidden={group === 1}
                    >
                        {Array.from({ length: 4 }).map((_, i) => (
                            <span
                                key={i}
                                className="px-12 py-2 text-sm font-semibold whitespace-nowrap"
                            >
                                {MESSAGE}
                            </span>
                        ))}
                    </div>
                ))}
            </div>

            <style>{`
                @keyframes marquee {
                    from { transform: translateX(0); }
                    to { transform: translateX(-50%); }
                }
            `}</style>
        </div>
    );
};

export default PromoBanner;
